/**
 * Maps mileage values to default plan mileages in the calculator:
 * - 0 returns 0 (no mileage)
 * - Low mileage and standard mileage map to 850
 * - High mileage and extra high mileage map to 1200
 *
 * Note: 850 mileage maps to 10000 annual mileage (Standard Commute) and 1200 mileage maps to 15000 annual mileage (Road Warrior).
 *
 * @param planMileage Selected plan mileage from session cart
 * @returns Default plan mileage for the V2 savings calculator
 */
export function getDefaultPlanMileage(planMileage?: number) {
  if (planMileage === 0) return 0; // low mileage -> 7,500 annual mileage (Errands & trips)

  return planMileage === 850 || planMileage === undefined
    ? 850 // standard mileage -> 10,000 annual mileage (Standard Commute)
    : 1200; // high and extra high mileage -> 15,000 annual mileage (Road Warrior)
}
